/**
 * Extracts swap types from a route array. Each swap type represents a specific type of 
 * token exchange operation in the route.
 * 
 * Swap Types:
 * 1 - Dragonswap V1
 * 2 - Yaka
 * 3 - Donkeswap
 * 4 - JellySwap
 * 5 - OkuTrade
 * 6 - Dragonswap V2
 * 7 - Sailorswap
 * 8 - Yei Finance
 * 9 - Oxium
 * 
 * @param {Array} route - The route array from getRoute response
 * 
 * @returns {Array<Array<number>>|undefined} Array of swap type arrays for each path, or undefined if route is invalid
 *   - For single path: [[1, 4, 1]] means Dragonswap V1 -> Jellyswap -> Dragonswap V1
 *   - For multi path: [[2, 4], [1, 4, 3]] means two paths:
 *      Path 1: Yaka -> Jellyswap
 *      Path 2: Dragonswap V1 -> Jellyswap -> Donkeswap
 * 
 * @example
 * // Example 1: Single path SEI -> USDC route through a pool
 * const route = await getRoute({
 *   tokenIn: "0x0", // SEI
 *   tokenOut: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48" // USDC
 * });
 * const swapTypes = getSwapTypes(route);
 * console.log(swapTypes); // [[2, 4, 1]] (YAKA -> JELLYSWAP -> DRAGONSWAP V1)
 
 */
export const getSwapTypes = (route) => {
  if (!route || !Array.isArray(route)) {
    console.error("Invalid or missing `route`: Must be an array.");
    return undefined;
  }
  const swapTypes = route.map((group) => group.map((item) => item.swapType));
  return swapTypes;
};
